import React, { useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { atomDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faCheckCircle } from '@fortawesome/free-solid-svg-icons';

interface CodeBlockProps {
    children: string;
    language?: 'bash' | 'json' | 'javascript' | 'typescript' | 'http' | 'text';
    title?: string;
    copyable?: boolean;
}

export default function CodeBlock({
    children,
    language = 'bash',
    title,
    copyable = true,
}: CodeBlockProps) {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(children);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="position-relative rounded overflow-hidden" style={{ backgroundColor: '#1d1f21' }}>
            {(title || copyable) && (
                <div
                    className="d-flex align-items-center justify-content-between px-3 py-2"
                    style={{ backgroundColor: '#2d2f31', borderBottom: '1px solid #3d3f41' }}
                >
                    {title && (
                        <span style={{ color: '#78909c',}} className="text-12">{title}</span>
                    )}
                    {!title && <span />}
                    {copyable && (
                        <button
                            onClick={handleCopy}
                            className="btn btn-sm p-0 border-0 text-12"
                            style={{
                                color: copied ? '#4caf50' : '#78909c',
                                backgroundColor: 'transparent',
                            }}
                        >
                            <FontAwesomeIcon icon={copied ? faCheckCircle : faCopy} className="me-1" />
                            {copied ? 'Copied!' : 'Copy'}
                        </button>
                    )}
                </div>
            )}
            <SyntaxHighlighter
                language={language}
                style={atomDark}
                customStyle={{
                    margin: 0,
                    padding: '1rem',
                    fontSize: 13,
                    backgroundColor: '#1d1f21',
                }}
                wrapLongLines
            >
                {children}
            </SyntaxHighlighter>
        </div>
    );
}
